const logger = require("@/utils/logger");
import VueAnalytics from 'vue-analytics'

const config = require("config");

const t0 = new Date().getTime()
window.t0 = t0
$(document).ready(function () {
  logger.log("Loaded in " + (new Date().getTime() - t0) + 'ms');
});
import Vue from 'vue'

Vue.use(require('vue-moment'))

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// light version of this: https://github.com/axios/axios/issues/690
// redirect to / when un-authenticated
Vue.axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  let originalRequest = error.config

  if (!(error.response)) {
    logger.log('Server is down?')
  } else if (error.response.status === 401) {
    router.push('/')
  }
  return Promise.reject(error)
})

Vue.config.productionTip = false

import LogoSVG from '@/components/common/LogoSVG'
Vue.component('logo-svg', LogoSVG)

import AppLogoName from '@/components/common/AppLogoName'
Vue.component('app-logo-name', AppLogoName)

import BaseLayout from '@/components/layouts/BaseLayout'
Vue.component('base-layout', BaseLayout)

import PopupLayout from '@/components/layouts/PopupLayout'
Vue.component('popup-layout', PopupLayout)

import AdminBaseLayout from '@/components/layouts/AdminBaseLayout'
Vue.component('admin-base-layout', AdminBaseLayout)

import UnauthenticatedLayout from '@/components/layouts/UnauthenticatedLayout'
Vue.component('unauth-layout', UnauthenticatedLayout)

import Loader from '@/components/common/Loader'
Vue.component('loader', Loader)

Vue.component('create-token', require('@/components/common/CreateToken').default)
Vue.component('root', require('@/components/layouts/RootComponent').default)

import App from './App'
import router from './router'

// https://medium.com/dailyjs/tips-tricks-for-vue-analytics-87a9d2838915
const prod = config.env == 'prod'
console.log('Production: ' + prod)
Vue.use(VueAnalytics, {
  id: 'UA-3208297-8',
  router,
  debug: {
    enabled: !prod,
    endHitTask: prod
  },
  autoTracking: {
    exception: true
  }
})

new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js